import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../utilities';

const initialState = {
    versions:{fires:[], clc:[]},
    selectedVersion_fires: 1,
    selectedVersion_clc: 2,
    savedVersion_fires:1,
    savedVersion_clc:2,
    newVersionAnalysed: false,
    newVersionUploaded: false,
    changedVersion: false
}


const getVersionsSuccess = (state,action) => {
    let versions = {fires:[], clc:[]};
    let nameAttach = "fires";
    let active = false;
    let selectedVersion_fires = 1;
    let selectedVersion_clc = 2;

    action.versions.forEach(version => {
        if (version.table === "fires") {
            nameAttach = "fires";
            if (version.active) selectedVersion_fires = version.id;

        } else if (version.table === "clc") {
            nameAttach = "clc";
            if (version.active) selectedVersion_clc = version.id;
        }

        if (version.active) active=true; else active=false;
        
        versions[nameAttach].push({value:version.id, label:version.version, active:active})
    });

    return updateObject(state, {
        versions:versions,
        selectedVersion_fires:selectedVersion_fires,
        selectedVersion_clc:selectedVersion_clc,
        savedVersion_fires: selectedVersion_fires,
        savedVersion_clc: selectedVersion_clc
    });
}

const updateAdminSimpleVariable = (state,action) => {
    return updateObject(state, {[action.variableName]:action.newValue});
}

const createVersionSuccess = (state,action) => {
    return updateObject(state, {newVersionAnalysed:true, newVersionUploaded:action.data});
}

const clearVersion = (state) => {
    return updateObject(state, {newVersionAnalysed:false, newVersionUploaded:false});
}


const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.GET_VERSIONS_SUCCESS: return getVersionsSuccess(state,action);
        case actionTypes.UPDATE_ADMIN_SIMPLE_VARIABLE: return updateAdminSimpleVariable(state,action);
        case actionTypes.CREATE_VERSION_SUCCESS: return createVersionSuccess(state,action);
        case actionTypes.CLEAR_VERSION: return clearVersion(state);
        default: return state;
    }
};

export default reducer;